module.exports = __webpack_public_path__ + "static/media/gear.aac2046a.svg";